/**
 * «Ko'p beriladigan savollar» — bosh sahifaning oxirgi bloki (alohida sahifa yo'q).
 * Savollar ro'yxati CMS'dan (`GET /portal/public/faq/`), bo'sh bo'lsa — namunaviy ro'yxat.
 * Baholash vidjeti (ЧТЗ 2.10) — alohida blok (`FeedbackSection`).
 */
import { useI18n } from "@/shared/i18n";
import { FAQ_ANCHOR } from "@/shared/lib/sectionRoutes";
import { Icon } from "@/shared/ui/Icon";

import { usePublicFaq } from "./helpers";

export function FaqSection() {
  const { t } = useI18n();
  const faqItems = usePublicFaq();

  return (
    <section className="section section-alt home-faq" id={FAQ_ANCHOR} aria-labelledby="faq-title">
      <div className="container">
        <div className="home-head" data-reveal>
          <div>
            <span className="eyebrow">{t("nav.faq")}</span>
            <h2 id="faq-title">Ko'p beriladigan savollar</h2>
            <p className="section-lead">
              Javob topilmasa — murojaat yuboring yoki ishonch telefoniga qo'ng'iroq qiling.
            </p>
          </div>
        </div>

        <div className="faq-single">
          <div className="faq" data-reveal>
            {faqItems.map((item, index) => (
              <details className="faq-item" key={item.question} open={index === 0}>
                <summary>
                  <span className="faq-cat">{item.category}</span>
                  <span className="faq-q">{item.question}</span>
                  <Icon name="chevronDown" size={18} />
                </summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
